import MComponent from '../Toolkit/Components/Component';
import React, {ReactElement} from 'react';
import styles from './MonthTotals.module.css';

type Props = {
    MonthTotals: number[];
    Year: number;
};

type State = {};

class MonthTotalsControl extends MComponent<Props, State> {

    private GetMonthText(monthNum: number): string{
        const date = new Date();
        date.setMonth(monthNum);

        return date.toLocaleString('en-US', { month: 'long' });
    }

    public render(): ReactElement {
        return <table className={styles.table}>
            <tbody>
            {this.props.MonthTotals.map((r, index) =>
                <tr key={index}>
                    <td className={styles.data}>{this.GetMonthText(index)}</td>
                    <td className={styles.data}>{r}</td>
                </tr>
            )}
            <tr key={-1}>
                <td className={styles.totals}>{`Total Plans for ${this.props.Year}`}</td>
                <td className={styles.totals}>{this.props.MonthTotals.reduce((accum, value) => accum + value, 0)}</td>
            </tr>
            </tbody>
        </table>;
    }
}

export default MonthTotalsControl;